import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Table,
    notification,
    Modal,
    Button,
    Image,
    Pagination,
    Input,
    Tooltip
} from "antd";
import axios from "axios";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { baseUrl } from "../../config";
import { skeletonData } from "../../components/skeletons/Blog";

const { Search } = Input;
const { confirm } = Modal;

// table code start
const columns = [
    {
        title: "#",
        dataIndex: "index",
        key: "index"
    },
    {
        title: "User Name",
        dataIndex: "userName",
        key: "userName"
    },
    {
        title: "Message",
        dataIndex: "message",
        key: "message"
    },
    // {
    //     title: "Type",
    //     dataIndex: "type",
    //     key: "type"
    // },
    {
        title: "Image",
        dataIndex: "image",
        key: "image"
    },
    // {
    //     title: "Short Content",
    //     dataIndex: "shortContent",
    //     key: "shortContent"
    // },
    {
        title: "Status",
        dataIndex: "status",
        key: "status"
    },
    {
        title: "Action",
        key: "action",
        dataIndex: "action",
    }
];

function ReviewList() {
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [privacy, setPrivacy] = useState('');
    const [titleName, setTitleName] = useState();

    useEffect(() => {
        getList()
    }, [searchTerm, currentPage, pageSize])

    async function getList() {
        try {
            setLoading(true);

            const params = {
                page: currentPage,
                items: pageSize,
            };

            // Check if search is not null or empty, then add it to params
            if (searchTerm && searchTerm.trim() !== '') {
                params.q = searchTerm;
                params.fields = 'userName,message'; // Specify searchable fields
                // params.fields = 'name,email'; // Specify searchable fields
            }

            // Make API call to submit form data
            const response = await axios.get(`${baseUrl}/api/review`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
                params
            });
            if (response.data.success) {
                setUserList(response.data.result);
                setTotalUsers(response.data.pagination.count);
            } else {
                setUserList([])
            }
            // Handle success response from the API
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight' // You can adjust the placement as needed
            });
            // Handle error response from the API
        } finally {
            setLoading(false); // End loading
        }
    };

    async function handleDelete(id) {
        try {
            const response = await axios.delete(`${baseUrl}/api/review/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                getList();
                notification.success({
                    message: 'Success',
                    description: 'Review deleted successfully!',
                    placement: 'topRight'
                });
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    //kamal
    const showDeleteConfirm = (id) => {
        confirm({
            title: 'Are you sure you want to delete this item?',
            icon: <ExclamationCircleOutlined />,
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(id);
            },
        });
    };

    const showModal = (privacy, name) => {
        setTitleName(name);
        setPrivacy(privacy || '')
        setModalVisible(true);
    };

    const handleOk = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = (value) => {
        if (value.length >= 3 || value.length === 0) {
            setSearchTerm(value);
            setCurrentPage(1);
        }
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Review"
                            extra={
                                <>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "space-between" }}>
                                        <Search
                                            placeholder="Search by user name, message"
                                            onSearch={handleSearch}
                                            allowClear
                                            style={{ flex: 1, minWidth: "200px" }} // Makes search bar flexible
                                        />
                                        <Link className="custom-btn" to="/review/add">Add</Link>
                                    </div>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : userList.map((user, index) => ({
                                        index: (currentPage - 1) * pageSize + index + 1,
                                        userName: user.userName,
                                        message: (<Tooltip title={user.message}>
                                            <span>
                                                {user.message?.split(' ').slice(0, 3).join(' ')}
                                                {user.message?.split(' ').length > 3 ? '...' : ''}
                                            </span>
                                        </Tooltip>),
                                        image: user.image ? <Image height="60px" width="60px" src={baseUrl + '/' + user.image} /> : '-',
                                        slug: user.slug,
                                        status: (
                                            <span className={user.enabled ? 'text-success' : 'text-danger'}>
                                                {user.enabled ? 'Active' : 'Inactive'}
                                            </span>
                                        ),
                                        action: (
                                            <div className="button-container">
                                                <Link to={`/review/update/${user._id}`} className="update-btn">
                                                    <EditOutlined />
                                                </Link>
                                                <button onClick={() => showDeleteConfirm(user._id)} className="delete-btn">
                                                    <DeleteOutlined />
                                                </button>
                                            </div>
                                        )
                                    }))}
                                    pagination={false}
                                    className="ant-border-space"
                                />
                            </div>
                            {/* Keep pagination outside the scrollable div */}
                            <div className="pagination-container">
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={totalUsers}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal
                title={`${titleName}`}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="author-info">
                    <div dangerouslySetInnerHTML={{ __html: privacy }} />
                </div>
            </Modal>
        </>
    );
}

export default ReviewList;
